import { useSessionStore } from '@/hooks/useSessionStore';
import { Button } from '@/components/ui/button';
import { cn } from '@/utils';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getDiscordUserInfoByToken, bindDiscordAccount } from '@/service/user';
import { toast } from 'sonner';

const Discord = () => {
  const sessionStore = useSessionStore();
  // const { isAuth } = useAuthCheck();
  const { session, fetchData } = sessionStore;
  const [searchParams] = useSearchParams();
  const [discordAccount, setDiscordAccount] = useState<{
    isBind: boolean | null;
    id?: string | null;
    name?: string | null;
    user_id?: string | null;
    errorToken: boolean;
  }>({
    isBind: null,
    id: null,
    name: null,
    errorToken: false,
  });
  const token = searchParams.get('token') || '';

  const getInfo = async () => {
    try {
      const { data } = await getDiscordUserInfoByToken({ token });
      setDiscordAccount({
        isBind: data.isBind,
        name: data.discordName,
        id: data.discordId,
        user_id: data.user_id,
        errorToken: false,
      });
    } catch (error: any) {
      setDiscordAccount({
        ...discordAccount,
        errorToken: true,
      });
      toast.error(error?.message || 'Error.');
    }
  };

  const bindAccount = async () => {
    if (!discordAccount.id) return;
    try {
      const { data } = await bindDiscordAccount({ discordId: discordAccount.id, userId: discordAccount.user_id });
      setDiscordAccount({
        ...discordAccount,
        isBind: true,
      });
    } catch (error: any) {
      toast.error(error?.message || 'Error.');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!session.isLoaded) return;
    if (discordAccount.isBind) return;
    if (token) {
      // user already login
      if (session.user.id) {
        getInfo();
      }
      // user not login yet
      else {
        localStorage.setItem('discordToken', token);
        window.location.replace('/login');
      }
    } else {
      sessionStorage.removeItem('discordToken');
    }
  }, [session]);

  console.log('discordAccount', discordAccount);

  if (!session.user.id) return null;

  if (discordAccount.errorToken)
    return (
      <div className="bg-jen-background-secondary pb-jen-spacing-96 w-full h-full px-[8px] lg:px-0">
        <div className="max-w-[1050px] mx-auto pt-72">
          <div className="flex justify-between flex-col lg:flex-row gap-[10px]">
            <div className="mt-jen-spacing-8 text-[32px] leading-[32px] ">Invalid token or token expired</div>
          </div>
        </div>
      </div>
    );

  return (
    <div className="bg-jen-background-secondary pb-jen-spacing-96 w-full h-full px-[8px] lg:px-0">
      <div className="max-w-[1050px] mx-auto pt-72 px-10 lg:px-20">
        {discordAccount.isBind === true && (
          <div className="flex justify-between flex-col lg:flex-row gap-[10px] w-full">
            <div className="text-center w-full">
              <div className="mt-jen-spacing-8 text-[32px] leading-[32px] ">Your Jen account is now connected with Discord.</div>
              <div className="mt-jen-spacing-16 text-[32px] leading-[32px] ">Please close this window.</div>
            </div>
          </div>
        )}
        {discordAccount.isBind !== true && token && (
          <>
            <p className="text-center text-[18px] lg:text-[32px]">Connect Discord with Your Jen Account</p>
            <div className="bg-white p-6 mt-6 rounded-xl border border-jen-border flex justify-between items-center min-h-32">
              <div className="">
                <span className="text-black/50">Jen Account</span>
                <br />
                {session.user.name}
              </div>
              {discordAccount.name && (
                <>
                  <div>
                    Discord Account
                    <br />
                    {discordAccount.name}
                  </div>
                </>
              )}
              <div>
                {
                  <Button
                    className={cn(
                      'cursor-pointer px-jen-spacing-16 py-jen-spacing-12 w-full border rounded-jen-spacing-8 border-jen-border flex justify-center items-center hover:opacity-80 bg-jen-interactive-primary text-jen-content-primary-contrast',
                    )}
                    onClick={bindAccount}
                  >
                    Connect
                  </Button>
                }
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Discord;
